import { createStyles } from "@mantine/core";

const useStyles = createStyles((theme) => ({
  marDetailModal: {
    "& .mantine-19pz3dh": {
      display: "none",
    },
    "& .mantine-Modal-body": {
      padding: 0,
    },
    "& .mantine-Paper-root": {
      overflow: "initial",
    },
    "& .mantine-Modal-content": {
      borderRadius: 0,
    },
  },
  moreRow: {
    display: "flex",
    "& p": {
      color: "#737373",
      fontSize: "12px",
      fontStyle: "normal",
      fontWeight: 600,
      lineHeight: "normal",
      cursor: "pointer",
      fontFamily: "Inter",
    },
  },
  header: {
    width: "100%",
    // height: "140px",
    // display: "flex",
    // flexDirection: "column",
    // justifyContent: "space-between",
    // alignItems: "center",
    gap: "10px",
    borderBottom: "1px solid #D9D9D9",
    paddingInline: "30px",
    "@media (max-width: 480px)": {
      paddingInline: "12px",
    },
    // marginTop: "20px",
    "& h2": {
      fontSize: "36px",
      fontWeight: 500,
    },
    "& p": {
      fontSize: "16px",
      fontWeight: 400,
      color: "#5C5C5C",
      textTransform: "uppercase",
    },
  },
  marHeader: {
    width: "100%",
    // height: "140px",
    display: "flex",
    // flexDirection: "column",
    justifyContent: "space-between",
    alignItems: "center",
    gap: "10px",
    borderBottom: "1px solid #D9D9D9",
    paddingInline: "30px",
    "@media (max-width: 480px)": {
      paddingInline: "12px",
    },
    // marginTop: "20px",
    "& h2": {
      fontSize: "36px",
      fontWeight: 500,
    },
    "& p": {
      fontSize: "16px",
      fontWeight: 400,
      color: "#5C5C5C",
      textTransform: "uppercase",
    },
  },
  cardWrapper: {
    display: "flex",
    alignItems: "flex-start",
    gap: "4px",
    marginBottom: 13,
  },
  selectionDot: {
    width: "15px",
    height: "15px",
    borderRadius: "50%",
    flexShrink: 0,
    transition: "background 0.15s",
  },
  // ── New card styles ──────────────────────────────────────────────────────
  newCard: {
    flex: 1,
    borderRadius: "8px",
    border: "1px solid #E5E5E5",
    overflow: "hidden",
    cursor: "pointer",
  },
  newCardTop: {
    padding: "8px 12px",
    gap: "8px",
    backgroundColor: "#fff",
    [theme.fn.smallerThan("sm")]: {
      flexWrap: "wrap",
    },
  },
  newCardFreq: {
    minWidth: "70px",
    fontFamily: "Inter",
    "& .freq": {
      fontSize: "16px",
      fontWeight: 600,
      color: "#404040",
    },
    "& .time": {
      fontSize: "10px",
      fontWeight: 400,
      color: "#737373",
      marginTop: "2px",
    },
    [theme.fn.smallerThan("sm")]: {
      flex: 1,
      minWidth: "unset",
    },
  },
  narcoticBadge: {
    display: "inline-block",
    backgroundColor: "#FEF3F2",
    color: "#B42318",
    fontSize: "12px",
    fontWeight: 500,
    padding: "2px 8px",
    borderRadius: "16px",
    fontFamily: "Inter",
    marginLeft: 5,
  },
  newCardMed: {
    flex: 1,
    fontFamily: "Inter",
    "& .name": {
      fontSize: "14px",
      fontWeight: 500,
      color: "#404040",
      wordBreak: "break-word",
    },
    "& .route": {
      fontSize: "10px",
      fontWeight: 400,
      color: "#737373",
      marginTop: "2px",
    },
    [theme.fn.smallerThan("sm")]: {
      width: "100%",
      flex: "none",
      order: -1,
    },
  },
  newCardQty: {
    minWidth: "60px",
    fontFamily: "Inter",
    "& .val": {
      fontSize: "14px",
      fontWeight: 500,
      color: "#404040",
    },
    "& .lbl": {
      fontSize: "10px",
      fontWeight: 400,
      color: "#737373",
    },
    [theme.fn.smallerThan("sm")]: {
      flex: 1,
      minWidth: "unset",
    },
  },
  newCardRemaining: {
    fontFamily: "Inter",
    minWidth: "70px",
    "& .val": {
      fontSize: "14px",
      fontWeight: 500,
      color: "#404040",
    },
    "& .lbl": {
      fontSize: "10px",
      fontWeight: 400,
      color: "#737373",
    },
    [theme.fn.smallerThan("sm")]: {
      flex: 1,
      minWidth: "unset",
    },
  },
  newCardBottom: {
    padding: "6px 12px",
    borderTop: "1px solid #E5E5E5",
    gap: "8px",
    [theme.fn.smallerThan("sm")]: {
      flexWrap: "wrap",
      gap: "6px",
    },
  },
  newCardBottomLabel: {
    fontSize: "10px",
    fontWeight: 400,
    fontFamily: "Inter",
    color: "#737373",
  },
  newCardBottomValue: {
    fontSize: "12px",
    fontWeight: 500,
    fontFamily: "Inter",
    color: "#404040",
  },
  modalBody: {
    margin: "20px",
    position: "sticky",
  },

  marMedBody: {
    width: "100%",
    display: "flex",
    flexDirection: "column",
    gap: "10px",
    maxHeight: "60vh",
    // maxHeight: "25vh",
    overflowY: "auto",
    padding: "20px",
    borderBottom: "1px solid #D9D9D9",
  },

  // CARD
  cardContainer: {
    width: "100%",
    height: "70px",
    borderRadius: "5px",
    display: "flex",
    wordBreak: "break-word",
    paddingInline: "20px",
    paddingBlock: "5px",
    alignItems: "center",
    justifyContent: "space-between",
    cursor: "pointer",
    "& p": {
      margin: 0,
    },
    "& h2": {
      margin: 0,
    },
    "& h3": {
      margin: 0,
    },
  },
  redText: {
    color: "#FF0000",
  },

  saveButton: {
    marginTop: "10px",
    display: "flex",
    justifyContent: "start",
    alignItems: "center",
    gap: "10px",
    "& button": {
      borderRadius: "5px",
      background: "rgba(255, 186, 69, 0.85)",
      width: "145px",
      height: "50px",
      color: "#000",

      fontSize: "26px",
      fontStyle: "normal",
      fontWeight: 500,
      lineHeight: "25px",

      "&:hover": {
        background: "rgba(255, 186, 69, 0.85)",
      },
    },
  },
  box1: {
    width: "200px",
    display: "flex",
    alignItems: "center",
    gap: "5px",
    "& > div": {
      "& h2": {
        fontSize: "16px",
        fontWeight: 600,
        // lineHeight: 1,
      },
      "& p": {
        fontSize: "8px",
        fontWeight: 300,
        // lineHeight: 1,
      },
    },
    "& > img": {
      width: "18px",
      height: "18px",
    },
  },
  box2: {
    flex: 1,
    display: "flex",
    flexDirection: "column",
    "& > p": {
      fontSize: "12px",
      fontWeight: 400,
      marginLeft: "5px",
      // lineHeight: 1,
    },
    "& > div": {
      display: "flex",
      gap: "10px",
      alignItems: "center",
      "& h2": {
        fontSize: "18px",
        fontWeight: 500,
        // lineHeight: 1,
      },
      "& p": {
        fontSize: "12px",
        fontWeight: 400,
        // lineHeight: 1,
      },
    },
  },
  box3: {
    width: "150px",
    "& > p:nth-of-type(1)": {
      fontSize: "8px",
      fontWeight: 300,
      textAlign: "center",
      // lineHeight: 1,
    },
    "& > p:nth-of-type(2)": {
      fontSize: "12px",
      fontWeight: 300,
      textAlign: "center",
      // lineHeight: 1,
    },
    "& > div": {
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      gap: "5px",
      "& > p": {
        fontSize: "16px",
        fontWeight: 600,
        textAlign: "center",
        // lineHeight: 1,
      },
    },
  },
  box4: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    flexDirection: "column",
    width: "70px",
    height: "38px",
    // border: "1px solid black",
    "& h3": {
      margin: "0",
      fontSize: "15px",
      fontWeight: 400,
      lineHeight: 1.4,
    },
    "& p": {
      margin: "0",
      textAlign: "center",
      fontSize: "6px",
      color: "#5C5C5C",
      lineHeight: "1",
    },
  },
  outOfmedication: {
    "& p": {
      color: "#fff !important",
    },
    "& h2": {
      color: "#fff !important",
    },
    "& h3": {
      color: "#fff !important",
    },
  },
  outcome: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    marginBottom: "20px",
  },
  quantityInput: {
    "& input": {
      borderRadius: "5px",
      width: "160px",
      height: "100px",
      border: "1px solid #979797",
      fontSize: "60px",
      fontWeight: "bold",
      textAlign: "center",
    },
  },
  dispensed: {
    display: "flex",
    // justifyContent: 'center',
    alignItems: "center",
    flexDirection: "column",
    "& h3": {
      fontWeight: "400",
      fontSize: "36px",
      margin: "0",
      marginBottom: "10px",
    },
  },
  radioContainer: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    gap: "20px",
    "& .mantine-1svz3tp": {
      color: "#232323",
      fontFamily: "Inter",
      fontSize: "16px",
      fontWeight: "800",
      lineHeight: "20px",
    },
    "& .mantine-1cu6yj8:checked": {
      background: "#FFBA45",
      borderColor: "#FFBA45",
    },
  },
  comments: {
    "& .mantine-1ix1d88": {
      borderRadius: "15px",
    },

    width: "90%",
    margin: "auto",
  },
  buttons: {
    display: "flex",
    justifyContent: "center",
    gap: "10px",
    alignItems: "center",
    flexDirection: "column",
    width: "min(420px, 92%)",
    margin: "1rem auto 5px auto",
  },
  topButtons: {
    display: "flex",
    justifyContent: "center",
    gap: "10px",
    alignItems: "center",
    flexWrap: "wrap",
  },
  datetimeInput: {
    "& .mantine-Input-wrapper": {
      "& .mantine-Input-input": {
        padding: "10px 14px 10px 36px",
      },
    },
  },

  inputStyle: {
    flex: 1,
    "& .mantine-Input-wrapper": {
      height: "auto",
      backgroundColor: "#FFFFFF",
      borderRadius: "8px",
      border: "1px solid #E5E5E5",
      boxShadow: "0px 1px 2px 0px rgba(16, 24, 40, 0.05)",
      "& .mantine-Input-input": {
        fontFamily: "Inter",
        border: "none",
        backgroundColor: "transparent",
        padding: "10px 14px",
        height: "44px",
        fontFamily: "Inter",
        color: "#262626",
      },
      "& .mantine-MultiSelect-input": {
        minHeight: "44px",
        maxHeight: "fit-content",
        height: "100%",
        padding: "0px",
        "& .mantine-MultiSelect-values": {
          minHeight: "inherit",
          padding: "10px 36px 10px 14px",

          "& .mantine-MultiSelect-searchInput": {
            minHeight: "100%",
            height: "100%",
          },
        },
      },
      "& .mantine-Textarea-input": {
        height: 100,
        overflowY: "auto",
      },
      "& .mantine-Select-rightSection svg, .mantine-MultiSelect-rightSection svg":
        {
          color: "#667085",
        },
    },
    "& .mantine-DateInput-wrapper, .mantine-DatePickerInput-wrapper": {
      "& .mantine-DateInput-icon, .mantine-DatePickerInput-icon": {
        "& svg": {
          color: "#262626",
          fontSize: 18,
        },
      },

      "& .mantine-DateInput-input, .mantine-DatePickerInput-input": {
        paddingLeft: "36px !important",
      },
    },
    "& .mantine-TimeInput-wrapper": {
      "& .mantine-TimeInput-icon": {
        "& svg": {
          color: "#262626",
          fontSize: 18,
        },
      },

      "& .mantine-TimeInput-input": {
        paddingLeft: "36px !important",
      },
    },
    "& .mantine-InputWrapper-label": {
      color: "#262626",
      marginBottom: "6px",
      fontFamily: "Inter",
      fontSize: "14px",
      fontWeight: 500,
    },
  },

  contentBox: {
    marginTop: 12,
    padding: "16px 14px",
    backgroundColor: "#FCFCFC",
    border: "1px solid #E5E5E5",
    borderRadius: "16px",
  },
  medScrollBox: {
    marginTop: 25,
    width: "100%",
    borderRadius: 8,
    backgroundColor: "#F5F5F5",
    display: "flex",
    flexDirection: "column",
    position: "relative",
    gap: "13px",
    maxHeight: "500px",
    overflowY: "auto",
    padding: "0px 11px 11px 11px",
    border: "1px solid #D0D5DD",
    [theme.fn.smallerThan("sm")]: {
      maxHeight: "calc(100dvh - 140px)",
      marginTop: 16,
    },
    "&::-webkit-scrollbar": {
      width: "8px",
    },
    "&::-webkit-scrollbar-track": {
      background: "#FFF",
      borderRadius: "6px",
    },
    "&::-webkit-scrollbar-thumb": {
      background: "#D4D4D4",
      borderRadius: "6px",
    },
  },
  medScrollBoxHdr: {
    paddingTop: 11,
    paddingBottom: 6,
    alignItems: "center",
    justifyContent: "space-between",
    position: "sticky",
    top: 0,
    zIndex: 1,
    backgroundColor: "#F5F5F5",
    "& .medScrollBoxHdrHdng": {
      fontSize: "16px",
      fontWeight: 600,
      fontFamily: "Inter",
      color: "#171717",
      margin: 0,
    },
  },
  statusLabel: {
    gap: "4px",
    alignItems: "center",
    fontSize: 12,
    fontWeight: 500,
    fontFamily: "Inter",
    "& img": {
      width: 36,
      height: 18,
    },
  },
  prnButton: {
    padding: "0px 18px",
    borderRadius: "8px",
    border: "1px solid #6941C6",
    backgroundColor: "#6941C6",
    height: 34,
    boxShadow: "0 1px 2px 0 rgba(16, 24, 40, 0.05)",
    fontSize: 16,
    fontWeight: 600,
    fontFamily: "Inter",
    color: "#FFF",
    ":hover": { backgroundColor: "#6941C6", opacity: 0.8 },
    [theme.fn.smallerThan("sm")]: {
      fontSize: 13,
      padding: "8px 14px",
      height: 38,
    },
  },
  saveBtn: {
    padding: "12px 20px",
    borderRadius: "8px",
    border: "1px solid #FFAF4A",
    backgroundColor: "#FFAF4A",
    height: 60,
    boxShadow: "0 1px 2px 0 rgba(16, 24, 40, 0.05)",
    fontSize: 18,
    fontWeight: 600,
    fontFamily: "Inter",
    color: "#262626",
    ":hover": {
      backgroundColor: "#FFAF4A",
      opacity: 0.8,
    },
  },
  unlimitedBadgeText: {
    // Unlimited
    color: "#344054",
    fontSize: 12,
    fontFamily: "Inter",
    fontWeight: "500",
    wordWrap: "break-word",
  },
  unlimitedBadge: {
    width: "100%",
    height: "100%",
    paddingLeft: 12,
    paddingRight: 12,
    paddingTop: 4,
    paddingBottom: 4,
    background: "#F2F4F7",
    borderRadius: 16,
    justifyContent: "center",
    alignItems: "center",
    display: "inline-flex",
  },
  datetimeInput: {
    "& .mantine-Input-wrapper": {
      "& .mantine-Input-input": {
        padding: "10px 14px 10px 36px",
      },
    },
  },

  inputStyle: {
    flex: 1,
    "& .mantine-Input-wrapper": {
      height: "auto",
      backgroundColor: "#FFFFFF",
      borderRadius: "8px",
      border: "1px solid #E5E5E5",
      boxShadow: "0px 1px 2px 0px rgba(16, 24, 40, 0.05)",
      "& .mantine-Input-input": {
        fontFamily: "Inter",
        border: "none",
        backgroundColor: "transparent",
        padding: "10px 14px",
        height: "44px",
        fontFamily: "Inter",
        color: "#262626",
      },
      "& .mantine-MultiSelect-input": {
        minHeight: "44px",
        maxHeight: "fit-content",
        height: "100%",
        padding: "0px",
        "& .mantine-MultiSelect-values": {
          minHeight: "inherit",
          padding: "10px 36px 10px 14px",

          "& .mantine-MultiSelect-searchInput": {
            minHeight: "100%",
            height: "100%",
          },
        },
      },
      "& .mantine-Textarea-input": {
        height: 100,
        overflowY: "auto",
      },
      "& .mantine-Select-rightSection svg, .mantine-MultiSelect-rightSection svg":
        {
          color: "#667085",
        },
    },
    "& .mantine-DateInput-wrapper, .mantine-DatePickerInput-wrapper": {
      "& .mantine-DateInput-icon, .mantine-DatePickerInput-icon": {
        "& svg": {
          color: "#262626",
          fontSize: 18,
        },
      },

      "& .mantine-DateInput-input, .mantine-DatePickerInput-input": {
        paddingLeft: "36px !important",
      },
    },
    "& .mantine-TimeInput-wrapper": {
      "& .mantine-TimeInput-icon": {
        "& svg": {
          color: "#262626",
          fontSize: 18,
        },
      },

      "& .mantine-TimeInput-input": {
        paddingLeft: "36px !important",
      },
    },
    "& .mantine-InputWrapper-label": {
      color: "#262626",
      marginBottom: "6px",
      fontFamily: "Inter",
      fontSize: "14px",
      fontWeight: 500,
    },
  },

  contentBox: {
    marginTop: 12,
    padding: "16px 14px",
    backgroundColor: "#FCFCFC",
    border: "1px solid #E5E5E5",
    borderRadius: "16px",
  },
  medScrollBox: {
    marginTop: 25,
    width: "100%",
    borderRadius: 8,
    backgroundColor: "#F5F5F5",
    display: "flex",
    flexDirection: "column",
    position: "relative",
    gap: "13px",
    maxHeight: "500px",
    overflowY: "auto",
    padding: "0px 11px 11px 11px",
    border: "1px solid #D0D5DD",
    [theme.fn.smallerThan("sm")]: {
      maxHeight: "calc(100dvh - 140px)",
      marginTop: 16,
    },
    "&::-webkit-scrollbar": {
      width: "8px",
    },
    "&::-webkit-scrollbar-track": {
      background: "#FFF",
      borderRadius: "6px",
    },
    "&::-webkit-scrollbar-thumb": {
      background: "#D4D4D4",
      borderRadius: "6px",
    },
  },
  medScrollBoxHdr: {
    paddingTop: 11,
    paddingBottom: 6,
    alignItems: "center",
    justifyContent: "space-between",
    position: "sticky",
    top: 0,
    zIndex: 1,
    backgroundColor: "#F5F5F5",
    "& .medScrollBoxHdrHdng": {
      fontSize: "16px",
      fontWeight: 600,
      fontFamily: "Inter",
      color: "#171717",
      margin: 0,
    },
  },
  statusLabel: {
    gap: "4px",
    alignItems: "center",
    fontSize: 12,
    fontWeight: 500,
    fontFamily: "Inter",
    "& img": {
      width: 36,
      height: 18,
    },
  },
  prnButton: {
    padding: "0px 18px",
    borderRadius: "8px",
    border: "1px solid #6941C6",
    backgroundColor: "#6941C6",
    height: 34,
    boxShadow: "0 1px 2px 0 rgba(16, 24, 40, 0.05)",
    fontSize: 16,
    fontWeight: 600,
    fontFamily: "Inter",
    color: "#FFF",
    ":hover": { backgroundColor: "#6941C6", opacity: 0.8 },
    [theme.fn.smallerThan("sm")]: {
      fontSize: 13,
      padding: "8px 14px",
      height: 38,
    },
  },
  saveBtn: {
    padding: "12px 20px",
    borderRadius: "8px",
    border: "1px solid #FFAF4A",
    backgroundColor: "#FFAF4A",
    height: 60,
    boxShadow: "0 1px 2px 0 rgba(16, 24, 40, 0.05)",
    fontSize: 18,
    fontWeight: 600,
    fontFamily: "Inter",
    color: "#262626",
    ":hover": {
      backgroundColor: "#FFAF4A",
      opacity: 0.8,
    },
  },
  unlimitedBadgeText: {
    // Unlimited
    color: "#344054",
    fontSize: 12,
    fontFamily: "Inter",
    fontWeight: "500",
    wordWrap: "break-word",
  },
  unlimitedBadge: {
    width: "100%",
    height: "100%",
    paddingLeft: 12,
    paddingRight: 12,
    paddingTop: 4,
    paddingBottom: 4,
    background: "#F2F4F7",
    borderRadius: 16,
    justifyContent: "center",
    alignItems: "center",
    display: "inline-flex",
  },
}));

export default useStyles;
